export default __webpack_public_path__ + "static/media/uploader-abbottLite-4.47084e38.png";